export const show = (element) => {
  element.classList.remove(element.dataset.hiddenClass || "hidden");
};

export const hide = (element) => {
  element.classList.add(element.dataset.hiddenClass || "hidden");
};
